class ProductCardScrollbar extends HTMLElement {
  connectedCallback() {
    this.scroller = this.closest('.relative')?.querySelector('[data-product-scroll]');
    if (!this.scroller) return;

    this.track = this.querySelector('[data-scroll-track]');
    this.thumb = this.querySelector('[data-scroll-thumb]');
    if (!this.track || !this.thumb) return;

    this.scroller.addEventListener('scroll', this.#update, { passive: true });
    this.#update();
  }

  disconnectedCallback() {
    this.scroller?.removeEventListener('scroll', this.#update);
  }

  #update = () => {
    const max = this.scroller.scrollWidth - this.scroller.clientWidth;
    if (max <= 0) {
      this.track.style.display = 'none';
      return;
    }
    this.track.style.display = '';
    const ratio = this.scroller.clientWidth / this.scroller.scrollWidth;
    const progress = this.scroller.scrollLeft / max;
    this.thumb.style.width = (ratio * 100) + '%';
    this.thumb.style.transform = 'translateX(' + (progress * (1 / ratio - 1) * 100) + '%)';
  };
}

if (!customElements.get('product-card-scrollbar')) {
  customElements.define('product-card-scrollbar', ProductCardScrollbar);
}
